// The one answer to "is india_masters on for this visitor" (#4967, #4985):
// on for everyone (a public flag), or on for this signed-in account (the
// allowlist; the server re-checks the account's verified token on every
// call). The landing page and /masters both ask here.
import { useAuth } from '../context/AuthContext';
import { useFeatureFlags } from '../context/FeatureFlagsContext';

export const MASTERS_FLAG = 'india_masters';

/** Pure: the flag's answer from the flags context's values. */
export function mastersFlagOn({ publicFlags, flags, forEmail, currentUser }) {
    return Boolean(publicFlags?.[MASTERS_FLAG])
        || (Boolean(currentUser) && Boolean(flags?.[MASTERS_FLAG]) && forEmail === currentUser.email);
}

/** Pure: whether the answer is final. A public "on" is final at once; an
 *  off waits for the public read and, signed in, the account's own read. */
export function mastersFlagReady({ publicFlags, publicReady, ready, forEmail, currentUser }, on) {
    if (on) return true;
    if (!publicReady && !publicFlags?.[MASTERS_FLAG]) return false;
    return !currentUser || (Boolean(ready) && forEmail === currentUser.email);
}

/** {on, ready, signedInEmail} for a page that is dark behind the flag. */
export default function useMastersFlag() {
    const { currentUser } = useAuth();
    const ff = useFeatureFlags({ mine: Boolean(currentUser), public: true }) || {};
    const values = { ...ff, currentUser };
    const on = mastersFlagOn(values);
    return { on, ready: mastersFlagReady(values, on), signedInEmail: currentUser?.email || null };
}
